export const CurrentDate = () => {
  const date: Date = new Date();
  return date;
};

export const Year = () => {
  const date = CurrentDate();
  const year = date.getFullYear();
  return year;
};

export const pageVariants = {
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

export const pageTransition = {
  ease: "easeOut",
  duration: 2,
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const teamsLocalisation = (data) => {
  const allLanguage = [
    "fr-CA",
    "vi-VN",
    "ru-RU",
    "ja-JP",
    "it-IT",
    "es-MX",
    "zh-CN",
    "ko-KR",
    "nl-NL",
    "pt-BR",
    "en-US",
    "de-DE",
    "es-ES",
    "tr-TR",
    "th-TH",
    "fr-FR",
    "zh-TW",
    "pl-PL",
    "en-GB",
  ];
  if (allLanguage.includes(data)) {
    return data;
  } else {
    return "en-US";
  }
};
